// import { BodyEncryption, axiosClient } from "@/app/apibinding/apiClient";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";
import { setLoader } from "./WorkFlowRedux";

export const WorkTeamInsert = createAsyncThunk(
  "WorkTeamInsert",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.INSERT,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const WorkTeamUpdate = createAsyncThunk(
  "WorkTeamUpdate",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.UPDATE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const WorkTeamDelete = createAsyncThunk(
  "WorkTeamDelete",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.DELETE,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const WorkTeamGetByPrimaryKey = createAsyncThunk(
  "WorkTeamGetByPrimaryKey",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.GET_BY_PRIMARY_KEY,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const WorkTeamGetTeamList = createAsyncThunk(
  "WorkTeamGetTeamList",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.GET_TEAM_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

// export const GetCurrentWorkFlow = createAsyncThunk(
//   "GetCurrentWorkFlow",
//   async (data, { dispatch }) => {
//     try {
//       dispatch(setLoader(true));
//       let resData = await apiCall(
//         {
//           method: "GET",
//           url: `${
//             API_URL.BASEURL + API_URL.WORKFLOW.GET_CURRENT_WORKFLOW
//           }?machineId=${data}`,
//           // body: data,
//         },
//         false
//       );
//       let response = apiResponse(false, resData);
//       dispatch(setLoader(false));
//       return response;
//     } catch (error) {
//       dispatch(setLoader(false));
//     }
//   }
// );

// export const GetDashBoardWorkFlowList = createAsyncThunk(
//   "GetDashBoardWorkFlowList",
//   async (data, { dispatch }) => {
//     try {
//       dispatch(setLoader(true));
//       let resData = await apiCall(
//         {
//           method: "GET",
//           url:
//             API_URL.BASEURL +
//             API_URL.WORKFLOW.GET_DASHBOARD_LIST +
//             `?recordLimit=${data}`,
//         },
//         false
//       );
//       let response = apiResponse(false, resData);

//       dispatch(setLoader(false));
//       return response;
//     } catch (error) {
//       dispatch(setLoader(false));
//     }
//   }
// );
// export const WorkFlowCopy = createAsyncThunk(
//   "WorkFlowCopy",
//   async (data, { dispatch }) => {
//     try {
//       dispatch(setLoader(true));
//       let resData = await apiCall(
//         {
//           method: "POST",
//           url: API_URL.BASEURL + API_URL.WORKFLOWCOPY,
//           body: data,
//         },
//         true
//       );
//       let response = apiResponse(true, resData);
//       dispatch(setLoader(false));
//       return response;
//     } catch (error) {
//       dispatch(setLoader(false));
//     }
//   }
// );
// export const UpdateWorkFlowStatus = createAsyncThunk(
//   "UpdateWorkFlowStatus",
//   async (data, { dispatch }) => {
//     try {
//       dispatch(setLoader(true));
//       let resData = await apiCall(
//         {
//           method: "POST",
//           url: API_URL.BASEURL + API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS,
//           body: data,
//         },
//         true
//       );
//       let response = apiResponse(true, resData);
//       dispatch(setLoader(false));
//       return response;
//     } catch (error) {
//       dispatch(setLoader(false));
//     }
//   }
// );
// export const UpdateWorkFlowRunningStatus = createAsyncThunk(
//   "UpdateWorkFlowRunningStatus",
//   async (data, { dispatch }) => {
//     try {
//       dispatch(setLoader(true));
//       let resData = await apiCall(
//         {
//           method: "POST",
//           url:
//             API_URL.BASEURL + API_URL.WORKFLOW.UPDATE_WORKFLOW_RUNNING_STATUS,
//           body: data,
//         },
//         true
//       );
//       let response = apiResponse(true, resData);
//       dispatch(setLoader(false));
//       return response;
//     } catch (error) {
//       dispatch(setLoader(false));
//     }
//   }
// );
const initialState = {
  WorkTeamInsertData: {
    data: null,
    error: null,
  },
  WorkTeamUpdateData: {
    data: null,
    error: null,
  },
  WorkTeamDeleteData: {
    data: null,
    error: null,
  },
  WorkTeamGetByPrimaryKeyData: {
    data: null,
    error: null,
  },
  WorkTeamGetTeamListData: {
    data: null,
    error: null,
  },
  // GetCurrentWorkFlowData: {
  //   data: null,
  //   error: null,
  // },
  // GetDashBoardWorkFlowListData: {
  //   data: null,
  //   error: null,
  // },
  // WorkFlowCopyData: {
  //   data: null,
  //   error: null,
  // },
  // UpdateWorkFlowStatusData: {
  //   data: null,
  //   error: null,
  // },
  // UpdateWorkFlowRunningStatusData: {
  //   data: null,
  //   error: null,
  // },
};

const WorkFlowTeamSlice = createSlice({
  name: "WORKFLOWTEAM",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    // setWorkFlowGetListData: (state) => {
    //   state.WorkFlowGetListData.data = null;
    // },
    // setGetWorkFlowByID: (state) => {
    //   state.GetWorkFlowByIDData.data = null;
    // },
  },

  extraReducers: (builder) => {
    builder
      .addCase(WorkTeamInsert.fulfilled, (state, action) => {
        state.WorkTeamInsertData.data = action.payload;
      })
      .addCase(WorkTeamInsert.rejected, (state, action) => {
        state.WorkTeamInsertData.error = action.error.message;
      })
      .addCase(WorkTeamUpdate.fulfilled, (state, action) => {
        state.WorkTeamUpdateData.data = action.payload;
      })
      .addCase(WorkTeamUpdate.rejected, (state, action) => {
        state.WorkTeamUpdateData.error = action.error.message;
      })
      .addCase(WorkTeamDelete.fulfilled, (state, action) => {
        state.WorkTeamDeleteData.data = action.payload;
      })
      .addCase(WorkTeamDelete.rejected, (state, action) => {
        state.WorkTeamDeleteData.error = action.error.message;
      })
      .addCase(WorkTeamGetByPrimaryKey.fulfilled, (state, action) => {
        state.WorkTeamGetByPrimaryKeyData.data = action.payload;
      })
      .addCase(WorkTeamGetByPrimaryKey.rejected, (state, action) => {
        state.WorkTeamGetByPrimaryKeyData.error = action.error.message;
      })
      .addCase(WorkTeamGetTeamList.fulfilled, (state, action) => {
        state.WorkTeamGetTeamListData.data = action.payload;
      })
      .addCase(WorkTeamGetTeamList.rejected, (state, action) => {
        state.WorkTeamGetTeamListData.error = action.error.message;
      });
    // .addCase(GetCurrentWorkFlow.fulfilled, (state, action) => {
    //   state.GetCurrentWorkFlowData.data = action.payload;
    // })
    // .addCase(GetCurrentWorkFlow.rejected, (state, action) => {
    //   state.GetCurrentWorkFlowData.error = action.error.message;
    // })
    // .addCase(GetDashBoardWorkFlowList.fulfilled, (state, action) => {
    //   state.GetDashBoardWorkFlowListData.data = action.payload;
    // })
    // .addCase(GetDashBoardWorkFlowList.rejected, (state, action) => {
    //   state.GetDashBoardWorkFlowListData.error = action.error.message;
    // })
    // .addCase(WorkFlowCopy.fulfilled, (state, action) => {
    //   state.WorkFlowCopyData.data = action.payload;
    // })
    // .addCase(WorkFlowCopy.rejected, (state, action) => {
    //   state.WorkFlowCopyData.error = action.error.message;
    // })
    // .addCase(UpdateWorkFlowStatus.fulfilled, (state, action) => {
    //   state.UpdateWorkFlowStatusData.data = action.payload;
    // })
    // .addCase(UpdateWorkFlowStatus.rejected, (state, action) => {
    //   state.UpdateWorkFlowStatusData.error = action.error.message;
    // })
    // .addCase(UpdateWorkFlowRunningStatus.fulfilled, (state, action) => {
    //   state.UpdateWorkFlowRunningStatusData.data = action.payload;
    // })
    // .addCase(UpdateWorkFlowRunningStatus.rejected, (state, action) => {
    //   state.UpdateWorkFlowRunningStatusData.error = action.error.message;
    // });
  },
});

// export const { setWorkFlowGetListData, setGetWorkFlowByID } =
//   WorkFlowTeamSlice.actions;
export default WorkFlowTeamSlice.reducer;
